import Box from "@memorang/ui/components/Box";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
/* -----------------UI--------------- */
import StatListItem from "components/StatListItem";
import { Fragment } from "react";
import { ExamContextListItem } from "./ExamContextListItem";

type Section = {
	title: string;
	data: {
		title: string;
		description?: string;
		icon?: string;
		type?: string;
		rightText?: string;
		action?: () => void;
	}[];
};

type Props = {
	sections: Section[];
};
const ProfileStatsView = ({ sections }: Props) => {
	return (
		<Box gap={8}>
			{sections.map(({ title, data }) => {
				return (
					<Fragment key={title}>
						<CustomListSubheaderContainer>{title}</CustomListSubheaderContainer>
						{data.map(
							({ type, icon, title, description, rightText }, index) => {
								return (
									<Box key={`${index}-${title}`}>
										{type === "exam" ? (
											<ExamContextListItem icon={icon} title={title} />
										) : (
											<Box paddingHorizontal={16}>
												<StatListItem
													title={title}
													description={description}
													icon={icon}
													rightText={rightText}
												/>
											</Box>
										)}
									</Box>
								);
							},
						)}
					</Fragment>
				);
			})}
		</Box>
	);
};

export default ProfileStatsView;
